import { render, staticRenderFns } from "./DetailedReport.vue?vue&type=template&id=a5a57616&scoped=true&lang=html&"
import script from "./DetailedReport.vue?vue&type=script&lang=js&"
export * from "./DetailedReport.vue?vue&type=script&lang=js&"
import style0 from "./DetailedReport.vue?vue&type=style&index=0&id=a5a57616&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a57616",
  null
  
)

export default component.exports